import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Select} from 'antd';
import {useDispatch} from 'react-redux';
import {IoMdAdd} from 'react-icons/io';
import IconBtn from '../../microComponents/elements/IconBtn';
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import GetRoleList from "./GetRolesList";
import Auth from "../../http_request/Model/auth/Auth";
import {MdOutlineEdit} from "react-icons/md";
import {toast} from "react-toastify";


const CreateEditUser = ({rowData}) => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const [branchLoading, setBranchLoading] = useState(false);
    const [filterBranch, setFilterBranch] = useState([]);
    const [roleListLoading, setRoleListLoading] = useState(false);
    const [roleList, setRoleList] = useState([]);
    const [changePass, setChangePass] = useState(!rowData);
    const handleShow = () => {

        setOpen(true);

    };

    useEffect(() => {

        form.setFieldsValue(rowData)

    }, [rowData, form])

    const onFinishFailed = (errorInfo) => {
    };

    const onFinish = (values) => {
        const handleReq = () => {
            Auth.request({
                beforeSend: () => {
                    setLoading(true)
                }, success: (result) => {
                    dispatch(getAgainHandler());
                    handleCancel()
                    form.resetFields()

                }, final: () => {
                    setLoading(false)
                }


            }).register(values, rowData?.userName)
        }

        if (!rowData) {

            if (values.password.length < 8) {
                toast.error('تعداد کاراکتر ها باید بیشتر از ۸ عدد باشد. ')
            } else {

                handleReq()
            }


        } else {
            if (values.password) {
                if (values.password.length < 8) {
                    toast.error('تعداد کاراکتر ها باید بیشتر از ۸ عدد باشد. ')
                } else {
                    handleReq()
                }
            } else {
                handleReq()
            }

        }


    };
    const handleCancel = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            getFilterBranch((e) => {
                setFilterBranch([{label: 'همه', value: 0}, ...e])
            }, setBranchLoading)

            GetRoleList((e) => {
                let res = []
                e.map((item) => {
                    return res = [...res, {label: item, value: item}]
                })
                setRoleList(res);
            }, setRoleListLoading)
        }


    }, [open]);


    return (
        <>
            <div onClick={handleShow}>
                {
                    rowData ?
                        <IconBtn color='orangeIconBtn' TooltipText='ویرایش کاربر'>
                            <MdOutlineEdit size={20} color='white'/>
                        </IconBtn>
                        :
                        <IconBtn color='greenIconBtn' TooltipText='اضافه کردن کاربر جدید'>
                            <IoMdAdd size={20} color='white'/>
                        </IconBtn>
                }
            </div>


            <Modal
                width={900}
                open={open}
                title={`${rowData ? 'ویرایش' : 'ایجاد'}   کاربر `}
                onCancel={handleCancel}
                footer={[
                    <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading} onClick={() => {
                        form.submit()
                    }}>
                        ثبت
                    </Button>,

                ]}
            >
                <Form
                    form={form}
                    name="basic"
                    layout='vertical'
                    onFinish={onFinish}
                    initialValues={{...rowData, changePass} || {}}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <div
                        className='grid  sm:grid-cols-2 md:grid-cols-3     gap-x-4  gap-y-5 mt-10   '>

                        <Form.Item
                            name="firstName"
                            label="نام"
                            rules={[{
                                required: true, message: 'لطفا نام را وارد کنید!',
                            },]}

                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name="lastName"
                            label="نام خانوادگی"
                            rules={[{
                                required: true, message: 'لطفا نام خانوادگی را وارد کنید!',
                            },]}

                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name="userName"
                            label="نام کاربری"
                            rules={[{
                                required: true, message: 'لطفا نام کاربری را وارد کنید!',
                            },]}

                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="branchId"
                            label="واحد"
                            rules={[{
                                required: true, message: 'لطفا واحد را وارد کنید!',
                            },]}

                        >


                            <Select showSearch
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                // optionFilterProp='name'
                                // fieldNames={{label: 'name', value: 'id'}}
                                    loading={branchLoading}
                                    options={filterBranch}/>
                        </Form.Item>
                        <Form.Item
                            name="roles"
                            label="سمت"
                            rules={[{
                                required: true, message: 'لطفا سمت را وارد کنید!',
                            },]}

                        >


                            <Select showSearch mode='multiple'
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                // optionFilterProp='name'
                                // fieldNames={{label: 'name', value: 'id'}}
                                    loading={roleListLoading}
                                    options={roleList}/>
                        </Form.Item>


                        {rowData && <Form.Item
                            name="changePass"
                            valuePropName="checked">
                            <Checkbox checked={changePass} onChange={(e) => {

                                setChangePass(e.target.checked)
                            }}>تغییر کلمه عبور </Checkbox>
                        </Form.Item>}
                        {changePass &&
                            <>
                                <Form.Item
                                    name="password"
                                    label="کلمه عبور"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'لطفا کلمه عبور را وارد کنید!',
                                        },
                                    ]}

                                >
                                    <Input.Password/>
                                </Form.Item>

                                <Form.Item
                                    name="confirm"
                                    label="تکرار کلمه عبور"
                                    dependencies={['password']}

                                    rules={[
                                        {
                                            required: true,
                                            message: 'لطفا کلمه عبور را وارد کنید!',
                                        },
                                        ({getFieldValue}) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('تکرار کلمه عبور درست نمی باشد!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password/>
                                </Form.Item>
                            </>
                        }</div>
                </Form> </Modal>
        </>

    );
};
export default CreateEditUser;